import { Slider, SliderProps } from '@components/slider';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormSliderProps<T = unknown> = FormFieldProps<SliderProps, T, boolean>;

export function FormSlider<T>(props: FormSliderProps<T>) {
  const formFieldProps = useFormField(props);

  return <Slider {...props} {...formFieldProps} />;
}
